<div data-testid="div-main-mesage-container" [ngClass]="[overlay === true?'overlay-container-custom':'']" (click)="removeMsg()">
  <div data-testid="div-toaster-message-item" id="toast-container" class="toast-center-custom" *ngFor="let item of notifications">
    <div data-testid="div-toaster-message" [ngClass]="[item.message !== undefined ?'show':'hidden']" class="toast {{cssClass(item) }}" aria-live="polite" style="display: block;">
      <button data-testid="btn-remove-noitification" type="button" class="toast-close-button" role="button" (click)="removeNotification(item)">×</button>
      <div data-testid="div-toaster-message-text" class="toast-message" [innerHTML]="item.message">
      </div>
    </div>
  </div>
</div>
 
